import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { CheckCircle2, Circle, DatabaseZap, X } from 'lucide-react';
import { API } from '../../../lib/api';
import { useAuth } from '../../../contexts/AuthContext';

const STEPS = [['customers', 'Customers and vehicles'], ['balances', 'Customer dues'], ['stock', 'Stock and parts'], ['vendors', 'Vendors and bills']];

// Dashboard card until the workshop has brought its data in (or hides it).
export const SetupChecklist = () => {
  const { user, authHeader } = useAuth();
  const [st, setSt] = useState(null);
  const allowed = user?.is_master_admin || user?.permissions?.can_manage_billing_settings;
  useEffect(() => {
    if (allowed) axios.get(`${API}/self-import/status`, { headers: authHeader() }).then((r) => setSt(r.data)).catch(() => {});
  }, [allowed, authHeader]);
  if (!st || st.dismissed) return null;
  const done = (k) => Boolean(st.results?.[k]) || (st.counts?.[k] || 0) > 0;
  const n = STEPS.filter(([k]) => done(k)).length;
  if (n === STEPS.length) return null;
  const hide = () => { setSt({ ...st, dismissed: true }); axios.post(`${API}/self-import/dismiss`, {}, { headers: authHeader() }).catch(() => {}); };
  return (
    <div className="mb-6 rounded-xl border border-teal-500/30 bg-teal-500/10 p-4" data-testid="setup-checklist">
      <div className="flex items-start gap-3">
        <DatabaseZap size={20} className="mt-0.5 shrink-0 text-teal-400" />
        <div className="min-w-0 flex-1">
          <p className="font-semibold text-white">Bring your data into Driveline <span className="text-xs font-normal text-slate-400">{n} of {STEPS.length} done</span></p>
          <p className="text-xs text-slate-400">Import from your old software or Excel yourself. Your data stays private to your workshop.</p>
          <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1">
            {STEPS.map(([k, l]) => (
              <span key={k} className={`inline-flex items-center gap-1 text-xs ${done(k) ? 'text-emerald-400' : 'text-slate-300'}`} data-testid={`setup-step-${k}`}>
                {done(k) ? <CheckCircle2 size={13} /> : <Circle size={13} />}{l}</span>))}
          </div>
        </div>
        <Link to="/admin/import" className="shrink-0 rounded-lg bg-teal-500 px-3 py-2 text-xs font-semibold text-slate-950 hover:bg-teal-400" data-testid="setup-checklist-open">Start import</Link>
        <button type="button" onClick={hide} className="text-slate-500 hover:text-white" title="Hide" data-testid="setup-checklist-dismiss"><X size={16} /></button>
      </div>
    </div>
  );
};
